import { render, staticRenderFns } from "./SMTPConfigForm.vue?vue&type=template&id=4d0ea42b&scoped=true"
import script from "./SMTPConfigForm.vue?vue&type=script&lang=js"
export * from "./SMTPConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ea42b",
  null
  
)

export default component.exports